import { Button, Modal, ModalContent, useDisclosure } from '@heroui/react'
import { ReturnsTrackingInfoResponseUploadDocumentsInfo } from '@itsrever/rever-api'
import { useTranslation } from 'react-i18next'
import { usePostHog } from '@posthog/react'
import { UploadPhotosDialog } from './upload-photos-dialog'

interface UploadPhotosProps {
  uploadDocumentsInfo: ReturnsTrackingInfoResponseUploadDocumentsInfo
}

export const UploadPhotos = ({ uploadDocumentsInfo }: UploadPhotosProps) => {
  const { t } = useTranslation()
  const posthog = usePostHog()
  const { isOpen, onOpen, onOpenChange } = useDisclosure()

  const handleOpen = () => {
    posthog?.capture('Upload Photos Started')
    onOpen()
  }

  const uploadedCount = uploadDocumentsInfo.uploaded_documents?.length ?? 0

  return (
    <section className="flex w-full items-center justify-between gap-8 border-l-2 border-blue-400 bg-blue-50 p-5 shadow-sm">
      <div className="space-y-1">
        <p className="text-sm font-medium">
          {t('tracking_new.upload_required_title')}
        </p>
        <p className="mt-0.5 text-xs font-normal">
          {uploadedCount > 0
            ? t('tracking_new.upload_already', { count: uploadedCount })
            : t('tracking_new.upload_hint')}
        </p>
      </div>
      <Button
        variant="bordered"
        radius="sm"
        size="sm"
        className="shrink-0 bg-white font-medium"
        onPress={handleOpen}
      >
        {t('tracking_new.upload_cta')}
      </Button>
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        scrollBehavior="inside"
        backdrop="blur"
        size="lg"
        className="rounded-md border border-solid border-neutral-200"
        classNames={{ backdrop: 'backdrop-blur-sm' }}
      >
        <ModalContent>
          {(onClose) => <UploadPhotosDialog onClose={onClose} />}
        </ModalContent>
      </Modal>
    </section>
  )
}
